import { render, staticRenderFns } from "./BumperBoxUpgrade.vue?vue&type=template&id=756f1482&scoped=true&"
import script from "./BumperBoxUpgrade.vue?vue&type=script&lang=js&"
export * from "./BumperBoxUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./BumperBoxUpgrade.vue?vue&type=style&index=0&id=756f1482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f1482",
  null
  
)

export default component.exports